export const hub = {
  news: {
    title: "News",
    relatedTitle: "Related News",
  },
  videos: {
    title: "Watch",
    relatedTitle: "More Videos",
  },
  reactionTitle: "What did you think?",
  errorTitle: "Something unexpected happened",
  reactions: {
    errorTogglingReaction: "Unable to toggle reaction",
    errorPostingComment: "Unable to post comment",
  },
  all: "All",
  commentCount: "{{ count }} Comments",
  placeholder: "Add a comment",
};
